import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CourseOverview = ({ course }) => {
  return (
    <div className="space-y-8">
      {/* Course Description */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h2 className="text-2xl font-heading font-semibold text-card-foreground mb-4">
          Sobre o Curso
        </h2>
        <div className="prose prose-sm max-w-none">
          <p className="text-muted-foreground font-caption leading-relaxed mb-4">
            {course?.fullDescription}
          </p>
          <p className="text-muted-foreground font-caption leading-relaxed">
            Este curso foi desenvolvido para profissionais que desejam aprofundar seus conhecimentos 
            e aplicar conceitos práticos em situações reais. Com uma abordagem hands-on, você 
            desenvolverá habilidades essenciais através de projetos práticos e estudos de caso.
          </p>
        </div>
      </div>
      {/* Learning Objectives */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h2 className="text-2xl font-heading font-semibold text-card-foreground mb-4">
          O que você vai aprender
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {course?.learningObjectives?.map((objective, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="w-6 h-6 bg-success text-success-foreground rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <Icon name="Check" size={14} />
              </div>
              <p className="text-muted-foreground font-caption">{objective}</p>
            </div>
          ))}
        </div>
      </div>
      {/* Course Requirements */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h2 className="text-2xl font-heading font-semibold text-card-foreground mb-4">
          Pré-requisitos
        </h2>
        <div className="space-y-3">
          {course?.requirements?.map((requirement, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="w-6 h-6 bg-accent text-accent-foreground rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <Icon name="Info" size={14} />
              </div>
              <p className="text-muted-foreground font-caption">{requirement}</p>
            </div>
          ))}
        </div>
      </div>
      {/* Instructor Profile */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h2 className="text-2xl font-heading font-semibold text-card-foreground mb-6">
          Sobre o Instrutor
        </h2>
        <div className="flex flex-col md:flex-row items-start space-y-4 md:space-y-0 md:space-x-6">
          <div className="w-24 h-24 rounded-full overflow-hidden flex-shrink-0">
            <Image
              src={course?.instructor?.avatar}
              alt={course?.instructor?.name}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-1">
            <h3 className="text-xl font-heading font-semibold text-card-foreground mb-2">
              {course?.instructor?.name}
            </h3>
            <p className="text-primary font-medium mb-3">{course?.instructor?.title}</p>
            <p className="text-muted-foreground font-caption leading-relaxed mb-4">
              {course?.instructor?.bio}
            </p>
            
            {/* Instructor Stats */}
            <div className="flex flex-wrap gap-6 text-sm">
              <div className="flex items-center space-x-2">
                <Icon name="GraduationCap" size={16} className="text-muted-foreground" />
                <span className="text-muted-foreground font-caption">
                  {course?.instructor?.coursesCount} cursos
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Users" size={16} className="text-muted-foreground" />
                <span className="text-muted-foreground font-caption">
                  {course?.instructor?.studentsCount} estudantes
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Star" size={16} className="text-muted-foreground" />
                <span className="text-muted-foreground font-caption">
                  {course?.instructor?.rating}/5 avaliação
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Course Statistics */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-card border border-border rounded-lg p-4 text-center">
          <div className="w-12 h-12 bg-primary text-primary-foreground rounded-full flex items-center justify-center mx-auto mb-3">
            <Icon name="PlayCircle" size={20} />
          </div>
          <p className="text-2xl font-heading font-bold text-card-foreground mb-1">
            {course?.lessonsCount}
          </p>
          <p className="text-sm text-muted-foreground font-caption">Lições</p>
        </div>
        
        <div className="bg-card border border-border rounded-lg p-4 text-center">
          <div className="w-12 h-12 bg-secondary text-secondary-foreground rounded-full flex items-center justify-center mx-auto mb-3">
            <Icon name="Clock" size={20} />
          </div>
          <p className="text-2xl font-heading font-bold text-card-foreground mb-1">
            {course?.duration}
          </p>
          <p className="text-sm text-muted-foreground font-caption">Duração</p>
        </div>
        
        <div className="bg-card border border-border rounded-lg p-4 text-center">
          <div className="w-12 h-12 bg-accent text-accent-foreground rounded-full flex items-center justify-center mx-auto mb-3">
            <Icon name="Users" size={20} />
          </div>
          <p className="text-2xl font-heading font-bold text-card-foreground mb-1">
            {course?.studentsCount}
          </p>
          <p className="text-sm text-muted-foreground font-caption">Estudantes</p>
        </div>
        
        <div className="bg-card border border-border rounded-lg p-4 text-center">
          <div className="w-12 h-12 bg-success text-success-foreground rounded-full flex items-center justify-center mx-auto mb-3">
            <Icon name="Award" size={20} />
          </div>
          <p className="text-2xl font-heading font-bold text-card-foreground mb-1">
            {course?.certificateAvailable ? "Sim" : "Não"}
          </p>
          <p className="text-sm text-muted-foreground font-caption">Certificado</p>
        </div>
      </div>
    </div>
  );
};

export default CourseOverview;